import React, { Component } from "react"
import { Segment, Label, Button, Grid, Image } from "semantic-ui-react"
import OwlCarousel from "react-owl-carousel"
import "owl.carousel/dist/assets/owl.carousel.css"
import "owl.carousel/dist/assets/owl.theme.default.css"
import "./CalculsPro.css"
import Peinture from "../../../assets/icons_works/1.png"
import Tapiserie from "../../../assets/icons_works/2.png"
import Béton from "../../../assets/icons_works/3.png"
import Chauffage from "../../../assets/icons_works/5.png"
import Pression from "../../../assets/icons_works/6.png"
import Eclairage from "../../../assets/icons_works/7.png"
import sol from "../../../assets/icons_works/8.png"
import Dimension from "../../../assets/icons_works/9.png"

class CalculsPro extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <Segment id="blocCalculsPro">
        {" "}
        <Segment id="blocCalculsProTitle">
          <h1 id="titleCalculsPro">Des calculs pour les PROS</h1>
          <h4 id="titleCalculsPro">
            Nous avons les outils pour vous permettre de calculer simplement et
            rapidement votre projet et ainsi préparer vos listes de
            <br /> courses en un minimum de temps.
          </h4>
        </Segment>
        <OwlCarousel
          id="carouselRadius"
          className="owl-theme"
          loop={5}
          items={5}
          nav
        >
          <div id="divRadius">
            <Segment id="sphere">
              <Image src={Peinture} size="mini" id="carouselRadiusSphere" />
            </Segment>
            <h4 id="titleSphere">Peinture</h4>
          </div>
          <div id="divRadius" class="item">
            <Segment id="sphere">
              <Image src={Tapiserie} id="carouselRadiusSphere" />
            </Segment>
            <h4 id="titleSphere">Tapiserie</h4>
          </div>
          <div id="divRadius" class="item">
            <Segment id="sphere">
              <Image src={Béton} id="carouselRadiusSphere" />
            </Segment>
            <h4 id="titleSphere"> &nbsp; &nbsp;Béton</h4>
          </div>
          <div id="divRadius" class="item">
            <Segment id="sphere">
              <Image src={Chauffage} id="carouselRadiusSphere" />
            </Segment>
            <h4 id="titleSphere">Chauffage</h4>
          </div>
          <div id="divRadius" class="item">
            <Segment id="sphere">
              <Image src={Pression} id="carouselRadiusSphere" />
            </Segment>
            <h4 id="titleSphere">Pression</h4>
          </div>
          <div id="divRadius" class="item">
            <Segment id="sphere">
              <Image src={Eclairage} id="carouselRadiusSphere" />
            </Segment>
            <h4 id="titleSphere">Eclairage</h4>
          </div>
          <div id="divRadius" class="item">
            <Segment id="sphere">
              <Image src={sol} id="carouselRadiusSphere" />
            </Segment>
            <h4 id="titleSphere"> &nbsp; &nbsp; &nbsp; &nbsp;Sol</h4>
          </div>
          <div id="divRadius" class="item">
            <Segment id="sphere">
              <Image src={Dimension} id="carouselRadiusSphere" />
            </Segment>
            <h4 id="titleSphere">Dimension</h4>
          </div>
        </OwlCarousel>
      </Segment>
    )
  }
}

export default CalculsPro



// WEBPACK FOOTER //
// ./src/components/Pro/AcceuilLandingPage/CalculsPro.js